export default __webpack_public_path__ + "156d9e8fdf66edb1139d1564f55eebac.png";